module.exports = ".circle {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.scss
// module id = ./web/modern/components/client/modals/upload-photo-modal/upload-photo-modal.scss
// module chunks = 0